module.exports = __webpack_public_path__ + "static/media/SDG17.f9e1b6d1.mp4";